// @flow
import React, { Component } from 'react'
import { Redirect, withRouter } from 'react-router-dom'
import Path from 'routes/path'
import moment from 'moment'
import { message as antdMessage } from 'antd'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { setUIState, containerIds } from 'redux/modules/ui'
import {
  actions as ReservationDetailActions,
  type State as ReservationDetailState,
} from 'redux/modules/reservationDetail'
import {
  actions as ReservationReputationActions,
  type State as ReservationReputationState,
} from 'redux/modules/reservationReputation'

import MainTemplate from 'components/templates/MainTemplate'
import ReservationReputationPage from 'components/pages/ReservationReputationPage'
import ReservationReputationForm from 'components/organisms/ReservationReputationForm'
import LoadingView from 'components/atoms/LoadingView'

import ReservationSidebarContainer from 'containers/organisms/ReservationSidebar'

import graphql from './graphql'
import { accountLoginUrl } from 'frontend_core/dist/helpers/url'

export type PropTypes = {
  match: {
    params: {
      ownerName: string,
    },
  },
  location: {
    pathname: string,
  },
  history: {
    replace: Function,
    push: Function,
  },
  ui: {
    isLoading?: ?boolean,
    isModalActive?: ?boolean,
    // フォームの値
    score?: ?number,
    description?: ?string,
    roomFeatures?: Array<string>,
    roomNps?: ?number,
    roomDescription?: ?string,
    nps?: ?string,
    serviceDescription?: ?string,
  },
  actions: {
    setUIState: Function,
    // ReservationDetail Actions
    fetchReservationDetail: Function,
    // ReservationReputation Actions
    fetchRoomFeatures: Function,
    fetchReputation: Function,
    createOrUpdateReputation: Function,
  },
  reservationDetail: ReservationDetailState,
  reservationReputation: ReservationReputationState,
}

class ReservationReputationPageContainer extends Component<PropTypes, *, *> {
  static async getInitialProps({ req, res, params, config, isLogin }) {
    if (!isLogin)
      return { redirect: { to: accountLoginUrl(config), status: 302 } }
    return
  }

  constructor(props: PropTypes) {
    super(props)
    this.canSave = this.canSave.bind(this)
    this.onClickSendConfirm = this.onClickSendConfirm.bind(this)
    this.onClickSend = this.onClickSend.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.onClickBackToMessage = this.onClickBackToMessage.bind(this)
    this.onChangeRoomFeatures = this.onChangeRoomFeatures.bind(this)
  }

  componentDidMount() {
    const {
      actions,
      reservationDetail,
      reservationReputation,
      match,
      data,
    } = this.props
    const { detail, messages } = reservationDetail

    // 直リンの場合の初期データ取得
    if (!detail.id) {
      actions.fetchReservationDetail({
        userId: data.viewer.id,
        reservationId: match.params.reservationId,
      })
    }
    if (reservationReputation.roomFeatures.length === 0) {
      actions.fetchRoomFeatures()
    }
    actions.fetchReputation({
      userId: data.viewer.id,
      reservationId: match.params.reservationId,
    })
    // モーダル閉じる
    this.closeModal()
    window.scrollTo(0, 0)
  }

  componentDidUpdate(prevProps: PropTypes) {
    const {
      actions,
      reservationReputation,
      match,
      config,
      data,
      history,
      location,
    } = this.props
    const { reservationReputation: prevReservationReputation } = prevProps

    // レビュー投稿成功したらメッセージに戻る
    if (
      reservationReputation.successCreateOrUpdateReputation &&
      !prevReservationReputation.successCreateOrUpdateReputation
    ) {
      antdMessage.success(i18n.t('page.shared.l_00034'))
      history.push(location.pathname)
      history.replace(Path.reservationDetail(match.params.reservationId))
    }

    // エラー系の表示
    if (
      reservationReputation.failedReputation !== null &&
      prevReservationReputation.failedReputation === null
    ) {
      antdMessage.warning(reservationReputation.failedReputation)
    }
  }

  onClickBackToMessage: Function
  onClickBackToMessage(e: Event) {
    const { history, location, match } = this.props
    e.preventDefault()
    history.push(location.pathname)
    history.replace(Path.reservationDetail(match.params.reservationId))
  }

  onClickSend: Function
  onClickSend() {
    const { actions, data, match, ui, reservationReputation } = this.props
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      isModalActive: false,
    })
    actions.createOrUpdateReputation({
      userId: data.viewer.id,
      reservationId: match.params.reservationId,
      hasCreated: reservationReputation.hasCreated,
      uiState: ui,
    })
  }

  onClickSendConfirm: Function
  onClickSendConfirm(e: Event) {
    const { actions, match } = this.props
    e.preventDefault()
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      isModalActive: true,
    })
  }

  closeModal: Function
  closeModal() {
    const { actions } = this.props
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      isModalActive: false,
    })
  }

  onChangeRoomFeatures: Function
  onChangeRoomFeatures(e: Event) {
    const { ui, actions } = this.props
    let roomFeatures = ui.roomFeatures || []
    if (e.target.checked) {
      roomFeatures.push(e.target.value)
    } else {
      roomFeatures = roomFeatures.filter(feature => {
        return feature !== e.target.value
      })
    }
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      roomFeatures,
    })
  }

  canSave: Function
  canSave() {
    const { ui } = this.props
    return (
      typeof ui.score === 'number' &&
      (typeof ui.description === 'string' &&
        ui.description.length >= 10 &&
        ui.description.length <= 400) &&
      typeof ui.roomNps === 'number' &&
      typeof ui.nps === 'number'
    )
  }

  render() {
    const {
      location,
      history,
      match,
      reservationDetail,
      reservationReputation,
      ui,
      actions,
      data,
    } = this.props
    const { detail, messages } = reservationDetail

    // レビューできない予約で直リンクした場合はメッセージ画面に戻す
    if (detail.id && !detail.can_be_reviewed) {
      antdMessage.warning(
        i18n.t('page.dashboard.reservation.error.cannotReputation'),
      )
      return (
        <Redirect to={Path.reservationDetail(match.params.reservationId)} />
      )
    }

    const descriptionErrorTexts = []
    if (!!ui.description) {
      if (ui.description.length === 0) {
        descriptionErrorTexts.push(i18n.t('error.formError.inputRequired'))
      }
      if (ui.description.length < 10) {
        descriptionErrorTexts.push(
          i18n.t('page.dashboard.reservation.reputationLengthTooShort'),
        )
      }
      if (ui.description.length > 400) {
        descriptionErrorTexts.push(
          i18n.t('page.dashboard.reservation.reputationLengthTooLong'),
        )
      }
    }

    return (
      <MainTemplate
        title={i18n.t('server.www.reservationReputation.title', {
          id: detail.id || '',
        })}
        isFixedHeader
        hideMustHeader
        hasFooter={false}
        {...this.props}
      >
        <ReservationReputationPage
          sidebarComponent={<ReservationSidebarContainer />}
          isShowContentsSp
          closeModal={this.closeModal}
          isModalActive={!!ui.isModalActive}
          onClickPositiveButton={this.onClickSend}
          isLoading={ui.isLoading}
        >
          <ReservationReputationForm
            isShowContentsSp
            score={{
              value: ui.score,
              onChange: value =>
                actions.setUIState(containerIds.RESERVATION_DETAIL, {
                  score: value,
                }),
            }}
            description={{
              value: ui.description,
              errorTexts: descriptionErrorTexts,
              onChange: e =>
                actions.setUIState(containerIds.RESERVATION_DETAIL, {
                  description: e.target.value,
                }),
            }}
            roomFeatures={{
              value: reservationReputation.roomFeatures.map(feature => ({
                label: feature.name_text,
                value: feature.name,
                checked: (ui.roomFeatures || []).includes(feature.name),
              })),
              onChange: this.onChangeRoomFeatures,
            }}
            roomNps={{
              value: ui.roomNps,
              onChange: value =>
                actions.setUIState(containerIds.RESERVATION_DETAIL, {
                  roomNps: value,
                }),
            }}
            roomDescription={{
              value: ui.roomDescription,
              onChange: e =>
                actions.setUIState(containerIds.RESERVATION_DETAIL, {
                  roomDescription: e.target.value,
                }),
            }}
            nps={{
              value: ui.nps,
              onChange: value =>
                actions.setUIState(containerIds.RESERVATION_DETAIL, {
                  nps: value,
                }),
            }}
            serviceDescription={{
              value: ui.serviceDescription,
              onChange: e =>
                actions.setUIState(containerIds.RESERVATION_DETAIL, {
                  serviceDescription: e.target.value,
                }),
            }}
            submitButton={{
              onClick: this.onClickSendConfirm,
              isDisabled: !this.canSave(),
            }}
            onClickBackToMessage={this.onClickBackToMessage}
          />
        </ReservationReputationPage>
      </MainTemplate>
    )
  }
}

function mapStateToProps(state) {
  return {
    ui: state.ui,
    reservationDetail: state.reservationDetail,
    reservationReputation: state.reservationReputation,
    config: state.config,
  }
}
function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = {
    setUIState,
    ...ReservationDetailActions,
    ...ReservationReputationActions,
  }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

const WrappedContainer = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(graphql(ReservationReputationPageContainer)),
)

export default WrappedContainer



// WEBPACK FOOTER //
// ./src/containers/pages/ReservationReputationPage/index.jsx